export const purchaseUrls = {
  futsal: 'https://www.compradigitalya.com/cart/42961147134023:1',
  highPerformance: 'https://www.compradigitalya.com/cart/42961147756615:1',
}

export const testimonials = [
  {
    initials: 'MR',
    name: 'Marcos R.',
    place: 'Buenos Aires · 34 años · Entrenador de Futsal',
    text: 'Che, lo compré el domingo y el lunes lo usé directo. Mis pibes notaron algo diferente aunque yo no les dije nada. La sesión tuvo otro ritmo y yo llegué a la cancha con todo mucho más claro.',
  },
  {
    initials: 'PL',
    name: 'Pablo L.',
    place: 'Córdoba · 39 años · Profe de Educación Física',
    text: 'Siempre armaba las sesiones de memoria y a último momento. Ahora abro el tomo, elijo y listo. Me salvó horas por semana y me permite adaptar sin perder el objetivo del entrenamiento.',
  },
  {
    initials: 'EG',
    name: 'Ezequiel G.',
    place: 'Rosario · 31 años · Preparador físico',
    text: 'Un pibe llegó con la rodilla jodida y antes no sabía ni qué decirle. Con el Bono 3 tuve el protocolo exacto y una forma ordenada de volver a cargar. Eso no tiene precio.',
  },
  {
    initials: 'NT',
    name: 'Nicolás T.',
    place: 'Mendoza · 36 años · Entrenador de Futsal competitivo',
    text: 'Lo del gym integrado con la cancha es lo que más me cambió. Antes hacían pesas por un lado y jugaban por el otro. Ahora todo conecta y se nota en la intensidad de los partidos.',
  },
  {
    initials: 'FR',
    name: 'Federico R.',
    place: 'La Plata · 42 años · Entrenador independiente',
    text: 'Subí los precios después de leer el Tomo 5 y no perdí ningún alumno. Al contrario, me empezaron a ver diferente porque ahora tengo una planificación seria para mostrarles.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Explosividad & Pliometría',
    period: '12 semanas listas',
    content: [
      'Saltos, arranques y reactividad específicos para Futsal',
      '12 semanas de progresiones listas para implementar',
      'Ejercicios de aterrizaje, desaceleración y potencia',
      'Sesiones adaptables a categorías formativas y competitivas',
    ],
  },
  {
    icon: '📗',
    name: 'Técnica & Control',
    period: 'Dominio bajo presión',
    content: [
      'Control orientado, conducción y pase bajo presión',
      'Tareas técnicas con objetivos claros y variantes',
      'Situaciones reducidas para tomar mejores decisiones',
      'Progresiones por nivel para grupos mixtos',
    ],
  },
  {
    icon: '📙',
    name: 'Velocidad & Agilidad',
    period: 'Cambios de ritmo y dirección',
    content: [
      'Sprints cortos específicos para Futsal',
      'Cambios de dirección, frenadas y re-aceleraciones',
      'Drills de agilidad aplicables a la cancha',
      'Progresión de carga para competir con más intensidad',
    ],
  },
  {
    icon: '📕',
    name: 'Estabilidad & Core',
    period: 'Prevención inteligente',
    content: [
      'Core funcional y estabilidad para movimientos explosivos',
      'Prevención para rodilla, tobillo, aductores y zona lumbar',
      'Protocolos de movilidad y activación pre-entreno',
      'Ejercicios que conectan fuerza, control y rendimiento',
    ],
  },
  {
    icon: '📓',
    name: 'Planificación Total',
    period: 'Temporada organizada',
    content: [
      'Temporada completa organizada de principio a fin',
      'Cómo unir cancha, gimnasio y recuperación',
      'Planificación semanal según objetivo competitivo',
      'Plantillas para seguir el progreso de tu equipo',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🏋️',
    'Fuerza Base Gym',
    'Programa de fuerza de 12 semanas para construir una base sólida, transferible y segura para tus jugadores.',
    '$12.000',
  ],
  [
    '02',
    '💥',
    'Potencia Explosiva Gym',
    'Método de contraste de 8 semanas para mejorar la potencia, los arranques y la capacidad de repetir esfuerzos.',
    '$12.000',
  ],
  [
    '03',
    '🦵',
    'Piernas Blindadas Gym',
    'Plan de prevención de lesiones de 10 semanas para rodilla, tobillo, aductores e isquiotibiales.',
    '$12.000',
  ],
  [
    '04',
    '💪',
    'Core de Acero Gym',
    'Cuatro tipos de trabajo de core orientados a la estabilidad, los giros y la potencia en Futsal.',
    '$12.000',
  ],
  [
    '05',
    '📅',
    'Gym Completo 12 Semanas',
    'Calendario integrado de gimnasio y cancha para que cada carga tenga sentido dentro de tu semana.',
    '$12.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién arranco como entrenador?',
    'Sí. El Tomo 1 tiene una progresión clara para que puedas dar tu primera sesión profesional desde el día uno, sin tener que inventar ejercicios sobre la marcha.',
  ],
  [
    '¿Cómo recibo el material?',
    'Por email en menos de 5 minutos después del pago. Vas a recibir los PDF listos para usar desde celular, tablet o computadora.',
  ],
  [
    '¿La garantía es real?',
    '100% real. Si en 7 días el sistema no te sirve, escribís a compradigitalyaa@gmail.com y te devolvemos el dinero. Sin preguntas ni formularios.',
  ],
  [
    '¿Sirve para grupos con distintos niveles?',
    'Sí. Cada tomo incluye ejercicios y progresiones que podés adaptar a grupos formativos, recreativos o competitivos sin perder el objetivo de la sesión.',
  ],
  [
    '¿Qué hago si un jugador llega lesionado?',
    'El Tomo 4 y el Bono 3 te dan protocolos de prevención y pautas específicas para las molestias más comunes del Futsal, para que tengas un criterio de trabajo claro.',
  ],
] as const

export const moreTestimonials = [
  {
    initials: 'SB',
    name: 'Santiago B.',
    place: 'Mar del Plata · 29 años · Entrenador de Futsal',
    text: 'Antes de esto laburaba de memoria. Ahora tengo todo organizado y mis pibes mejoraron un montón en los torneos. Cada semana sé exactamente qué buscar y cómo subir la intensidad.',
  },
  {
    initials: 'DM',
    name: 'Diego M.',
    place: 'Santa Fe · 37 años · Preparador físico',
    text: 'El calendario de gym integrado con la cancha es una locura. Por primera vez siento que el trabajo físico se ve en el partido y no queda separado en una planilla.',
  },
  {
    initials: 'JC',
    name: 'Javier C.',
    place: 'Tucumán · 33 años · Entrenador de Futsal competitivo',
    text: 'Mis pibes reaccionan mucho más rápido que antes. Los ejercicios de reacción del Alto Rendimiento son un nivel aparte y se integran fácil a lo que ya veníamos haciendo.',
  },
  {
    initials: 'AL',
    name: 'Agustín L.',
    place: 'Neuquén · 41 años · Coordinador de inferiores',
    text: 'Lo que más valoro es la progresión. Pude ordenar a todas las categorías con una lógica común y dejar de repetir tareas porque sí. Ahora cada sesión tiene un porqué.',
  },
  {
    initials: 'GS',
    name: 'Germán S.',
    place: 'San Juan · 35 años · Entrenador de club',
    text: 'Me dio una forma profesional de planificar aun cuando tengo poco tiempo. Llego a la semana con la cancha, el gym y las recuperaciones mucho más coordinados.',
  },
]
